import React from 'react';
import { useNavigate } from 'react-router-dom';

function ForexPage() {
  const navigate = useNavigate();

  const features = [
    { title: "24/5 İşlem", description: "Hafta içi 24 saat işlem yapma imkanı", icon: "🕐" },
    { title: "Düşük Spread", description: "Rekabetçi alış-satış farkları", icon: "💹" },
    { title: "Yüksek Likidite", description: "Dünyanın en likit piyasası", icon: "💧" },
    { title: "Küresel Erişim", description: "Dünyanın en büyük para piyasası", icon: "🌐" }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">FOREX</h1>
          <div className="w-6"></div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto py-12 px-4">
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-3xl font-bold text-[#1e5a8e] mb-4">Forex Piyasaları</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            35 Yıllık tecrübesi ile Dünyanın en büyük finans piyasası olan FOREX'te 
            avantajlı şartlarla işlem yapın.
          </p>
          <p className="text-gray-600 leading-relaxed">
            Forex (Foreign Exchange), yabancı para birimlerinin alınıp satıldığı dünyanın 
            en büyük ve en likit finansal piyasasıdır. Günlük işlem hacmi 6 trilyon doları aşmaktadır.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="text-4xl mb-3">{feature.icon}</div>
              <h3 className="font-bold text-[#1e5a8e] mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1e5a8e] to-[#26c6da] rounded-lg shadow-lg p-8 text-white">
          <h3 className="text-2xl font-bold mb-4">Forex İşlem Yapmaya Başlayın</h3>
          <p className="mb-6 opacity-90">
            Profesyonel trading platformumuz ile forex piyasalarında işlem yapmaya hemen başlayın.
          </p>
          <button 
            onClick={() => navigate('/login')}
            className="px-8 py-3 bg-white text-[#1e5a8e] rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Hesap Aç
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForexPage;
